/* used to interface with the persondata functions in ELE */

ele.persondata = (function(){
	
	return {
		/* get the settings object for a user */
		getSettings: function(callback) {
			$.ajax({
	  			type: "POST",
				url: ele.uri.buildUrl("personDataRead"),
				data: {
					ajax: 1,
					persondatatype: "config"
				},
				dataType: "json",
				success: function(data){
				
					if (data != "") {
						return data;
					} 
					callback({});
				},
				error: function() {
					callback({});
				}
			});
		},
		
		/* set the settings object for a user (only setting the keys sent and 
		 * not overwriting the existing values)
		 */
		setSetting: function(userkey, uservalue, callback, callbackFailure) {
						
			$.ajax({
	  			type: "POST",
				url: ele.uri.buildUrl("personData"),
				data: {
					ajax: 1,
					persondatatype: "config",
					persondatakeyname: userkey,
					persondatastring: uservalue
				},
				dataType: "json",
				success: callback,
				error: callbackFailure
			});
		}
		
	}
})();